export default {
      id: "e-ifu-usage",
      viewBox: "0 0 45.3543 45.3543",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#e-ifu",
      toString: function () {
        return this.url;
      }
    }